/**
 * @fileoverview Layout constants of the student matrix — a copy of the teacher tracker's `tableHelpers`
 * so both grids look identical (sticky header + sticky first column, same widths and borders).
 */

import type { CSSProperties } from 'react'

export const STUDENT_COLUMN_MIN_WIDTH = 200
export const SUB_COLUMN_MIN_WIDTH = 100
/** Self / Teacher for the final assessment column (no deliverable). */
export const FINAL_SUBCOLS = 2

const TABLE_MAX_HEIGHT = '70vh'
const HEADER_BACKGROUND = 'var(--mantine-color-gray-1, #f1f3f5)'
const STICKY_EDGE_SHADOW = '1px 0 0 var(--mantine-color-gray-3, #dee2e6)'

const Z_STICKY_COLUMN = 1
const Z_STICKY_HEADER = 2
const Z_STICKY_CORNER = 3

export const scrollContainerStyle: CSSProperties = { overflow: 'auto', maxHeight: TABLE_MAX_HEIGHT }

export const tableStyle: CSSProperties = { borderCollapse: 'separate', borderSpacing: 0 }

export const stickyTheadStyle: CSSProperties = { position: 'sticky', top: 0, zIndex: Z_STICKY_HEADER }

const stickyBase: CSSProperties = {
  position: 'sticky',
  left: 0,
  backgroundColor: 'var(--mantine-color-body, #fff)',
  width: STUDENT_COLUMN_MIN_WIDTH,
  minWidth: STUDENT_COLUMN_MIN_WIDTH,
  boxShadow: STICKY_EDGE_SHADOW,
}

export const stickyHeaderStyle: CSSProperties = {
  ...stickyBase,
  backgroundColor: HEADER_BACKGROUND,
  zIndex: Z_STICKY_CORNER,
}
export const stickyBodyStyle: CSSProperties = { ...stickyBase, zIndex: Z_STICKY_COLUMN }

export const headerCellStyle: CSSProperties = {
  backgroundColor: HEADER_BACKGROUND,
  verticalAlign: 'top',
  textAlign: 'center',
}

export const subHeaderStyle: CSSProperties = {
  minWidth: SUB_COLUMN_MIN_WIDTH,
  fontWeight: 500,
  fontSize: '0.75rem',
  color: 'var(--mantine-color-dimmed, #868e96)',
  whiteSpace: 'normal',
  textAlign: 'center',
  backgroundColor: HEADER_BACKGROUND,
}

export const legendFooterStyle: CSSProperties = {
  borderTop: '1px solid var(--mantine-color-gray-3, #dee2e6)',
  padding: '12px 16px',
  backgroundColor: 'var(--mantine-color-body, #fff)',
}

export const cellStyle: CSSProperties = { verticalAlign: 'middle', textAlign: 'center' }

/** Number of sub-columns a lesson occupies: self + teacher when assessable, plus one per deliverable. */
export function subColCount(lesson: { hasAssessments: boolean; deliverableActivities: unknown[] }): number {
  return (lesson.hasAssessments ? 2 : 0) + lesson.deliverableActivities.length
}
